export const GET_VERSIONS = "GET_VERSIONS";
export const GENERATE_NEW_VERSION = "GENERATE_NEW_VERSION";
